"use client";
import callApi from "Common/utils/apiCaller";
import AsyncSelect from "react-select/async";
import { useEffect, useState } from "react";
import { apiConfig } from "./apiConfig";
import { showNotification } from "Common/utils/Notification";

interface Filters {
  announcement_type?: string;
  is_published?: boolean;
  tags?: string[];
  is_version_copy?: boolean;
}
const DynamicLink = ({ showLink, toggleLink, setLink }) => {
  const [staticLink, setStaticLink] = useState(null);
  const [linkData, setLinkData] = useState(null);
  const [key, setKey] = useState(0); // Unique key to force re-render
  const [inputLink, setInputLink] = useState("");

  // Fetch dynamic links (Main Dropdown)
  const loadDynamicOptions = async (inputValue) => {
    const res = await callApi(`v1/content/code/page-types`, "get", {});
    if (res.status === "Success") {
      return res.data.content.params
        .filter((item) =>
          item.label.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((item) => ({ label: item.label, value: item.value }));
    }
    return [];
  };

  // Fetch sublinks based on selection (Second Dropdown)
  const loadSubLinkOptions = async (selectedOption, inputValue) => {
    if (!selectedOption) return [];

    const config = apiConfig[selectedOption.value];
    if (!config?.endpoint) return [];
    let filters: Filters = {};
    filters.is_version_copy = false;
    if (staticLink?.value === "announcement") {
      filters.announcement_type = "document";
      filters.is_published = true;
    } else if (staticLink?.value === "video") {
      filters.tags = ["video"];
    } else if (staticLink?.value === "podcast") {
      filters.tags = ["podcast"];
    }
    const res = await callApi(config.endpoint, config.method, { filters });
    if (res.status === "Success") {
      const data =
        config.key === "params"
          ? res.data?.content?.[config.key] || []
          : res.data?.[config.key] || [];
      return data
        .filter((item) =>
          item?.[config.labelKey]
            .toLowerCase()
            .includes(inputValue.toLowerCase())
        )
        .map((item) => ({
          label: item?.[config.labelKey],
          value: item?.[config.valueKey],
        }));
    }
    return [];
  };

  const handleSave = () => {
    if (!staticLink?.value) {
      showNotification("Please select a link");
      return;
    }

    let data = `${
      !["custompages", "podcast", "video", "externallink"].includes(
        staticLink?.value
      )
        ? `/${staticLink?.value}`
        : ""
    }${linkData?.value ? `/${linkData?.value}` : ""}${
      inputLink ? `${inputLink}` : ""
    }`;

    toggleLink(!showLink);
    setLink(data);
    setStaticLink(null);
    setLinkData(null);
  };

  return (
    <>
      <AsyncSelect
        key={key}
        loadOptions={loadDynamicOptions}
        defaultOptions
        isSearchable={true}
        placeholder="Please select link"
        value={staticLink}
        onChange={(option) => {
          setStaticLink(option);
          setLinkData(null);
          setInputLink("");
          setKey((prevKey) => prevKey + 1);
        }}
      />

      {staticLink && apiConfig[staticLink.value]?.endpoint && (
        <div className="mt-5">
          <AsyncSelect
            key={key}
            loadOptions={(inputValue) =>
              loadSubLinkOptions(staticLink, inputValue)
            }
            defaultOptions
            isSearchable={true}
            placeholder="Please select sublink"
            value={linkData}
            onChange={(option) => {
              setLinkData(option);
              setInputLink("");
            }}
          />
        </div>
      )}

      {staticLink?.value === "externallink" && (
        <div className="mt-5">
          <input
            key={key}
            type="text"
            value={inputLink}
            placeholder="Enter external link"
            className="form-input border-slate-200 focus:outline-none"
            onChange={(e) => setInputLink(e.target.value)}
          />
        </div>
      )}

      <div className="flex justify-end gap-2 mt-10">
        <button
          type="reset"
          className="text-red-500 bg-white btn hover:text-red-500"
          onClick={() => {
            toggleLink(!showLink);
            setStaticLink(null);
            setLinkData(null);
            setInputLink("");
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          type="submit"
          className="text-white btn bg-custom-500"
        >
          Save
        </button>
      </div>
    </>
  );
};

export default DynamicLink;
